import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface BenefitApiParameter extends ApiParameter {
    benefitForm: Partial<BenefitFormModel>;
}

export interface BenefitFormModel {
    password: string;
}



export async function benefitService(parameter: BenefitApiParameter): Promise<ServiceResult<BenefitFormModel>> {
    try {
        const result = await post<BenefitFormModel>(`api/benefitsguide/${parameter.benefitForm.password}`, parameter.benefitForm as BenefitFormModel);
        
        return {
            result,
            successful: true,
        };
    } catch (error) {
        
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}